import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Users, Rocket, ArrowUpRight } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const Pourquoi = () => {
  const { t } = useT();

  const pillars = [
    { icon: Users, tag: "p1" },
    { icon: Sparkles, tag: "p2" },
    { icon: Rocket, tag: "p3" },
  ];

  return (
    <div data-testid="pourquoi-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 hx-dot-grid opacity-50" />
        <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#1093f0]/10 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12">
          <div className="text-xs mono uppercase tracking-[0.3em] text-[#1093f0] mb-4">{t("pourquoiPage.kicker")}</div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-[#131517] leading-[1.02] max-w-4xl">
            {t("pourquoiPage.title1")}<br />
            <span className="italic font-normal">{t("pourquoiPage.title2")}</span>
          </h1>
          <p className="mt-8 text-lg text-[#3f444b] max-w-2xl">{t("pourquoiPage.desc")}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 space-y-5">
        {pillars.map(({ icon: Icon, tag }, i) => (
          <div
            key={tag}
            className="grid lg:grid-cols-12 gap-8 bg-[#f4f5f6] rounded-3xl p-10 lg:p-14 hx-card"
            data-testid={`pillar-${i}`}
          >
            <div className="lg:col-span-1">
              <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#1093f0]" />
              </div>
            </div>
            <div className="lg:col-span-11">
              <h2 className="text-3xl lg:text-4xl font-semibold text-[#131517] mb-4">{t(`pourquoiPage.${tag}.title`)}</h2>
              <p className="text-lg text-[#3f444b] leading-relaxed max-w-3xl">{t(`pourquoiPage.${tag}.desc`)}</p>
            </div>
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-28">
        <div className="rounded-3xl bg-[#131517] text-white p-12 lg:p-20 hx-grain relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#1093f0]/20 blur-3xl" />
          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <h2 className="text-4xl lg:text-6xl font-semibold leading-[1.05]">
                {t("pourquoiPage.ctaTitle")}
              </h2>
              <p className="mt-6 text-lg text-[#9ca0a6] max-w-xl">
                {t("pourquoiPage.ctaDesc")}
              </p>
            </div>
            <div className="lg:col-span-4">
              <Link
                to="/contact?type=join"
                className="hx-btn-primary inline-flex items-center justify-between gap-2 bg-[#1093f0] text-white px-7 py-5 rounded-full text-sm font-semibold w-full"
                data-testid="pourquoi-join-cta"
              >
                {t("pourquoiPage.ctaButton")} <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pourquoi;
